import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const steps = [{
  id: 1,
  label: 'STEP 01',
  title: 'Search & filter local businesses',
  description: 'Start by building your ideal audience. Filter through 200M+ local businesses by location, industry, revenue, and employee count to find exactly who you need.',
  image: 'https://cdn.magicpatterns.com/uploads/gV7JHHXgbCBdaBrQXT1vTQ/Search_Filter.gif',
  alt: 'Openmart search and filter interface showing local business results'
}, {
  id: 2,
  label: 'STEP 02',
  title: 'Enrich with business intelligence',
  description: 'Select your target accounts and enrich them instantly. Openmart finds verified owner emails, direct phone numbers, and detects the tech stack they use.',
  image: 'https://cdn.magicpatterns.com/uploads/4E8XS6hq3erKBoQYVewHu3/Enrichment_Results.gif',
  alt: 'Openmart enrichment results showing verified contacts and tech stack data'
}, {
  id: 3,
  label: 'STEP 03',
  title: 'Launch email sequences',
  description: "Don't just export data—act on it. Push your enriched contacts directly into built-in email sequences to start conversations with local business owners immediately.",
  image: 'https://cdn.magicpatterns.com/uploads/ua17rCrXcbRSJeVyikT2pZ/outreach_email_template.png',
  alt: 'Openmart email sequence editor with personalized template variables'
}];
export function EnrichmentProductTour() {
  return <section className="py-40 bg-white relative overflow-hidden" data-id="element-2861">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2862">
        <div className="text-center max-w-3xl mx-auto mb-32" data-id="element-2863">
          <div className="text-sm font-bold text-blue-600 tracking-widest uppercase mb-4" data-id="element-2864">
            Product Tour
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight tracking-tight" data-id="element-2865">
            See the <span className="text-blue-600" data-id="element-2866">product in action</span>
          </h2>
          <p className="text-xl text-slate-500 leading-relaxed" data-id="element-2867">
            A complete workflow from finding local businesses to launching
            personalized outreach.
          </p>
        </div>

        <div className="space-y-36 md:space-y-52" data-id="element-2868">
          {steps.map((step, index) => {
          const isEven = index % 2 !== 0;
          return <div key={step.id} className={`flex flex-col ${isEven ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-16 lg:gap-28 items-center`} data-id="element-2869">
                {/* Text Content */}
                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.7,
              delay: 0,
              ease: [0.25, 0.1, 0.25, 1]
            }} className="w-full lg:w-5/12 space-y-8" data-id="element-2870">
                  <div className="text-sm font-bold text-slate-400 tracking-widest uppercase" data-id="element-2871">
                    {step.label}
                  </div>
                  <h3 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight leading-tight" data-id="element-2872">
                    {step.title}
                  </h3>
                  <p className="text-lg text-slate-500 leading-relaxed" data-id="element-2873">
                    {step.description}
                  </p>
                  <div className="pt-2" data-id="element-2874">
                    <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-blue-600 font-semibold hover:text-blue-700 transition-colors group" data-id="element-2875">
                      Try for free
                      <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-2876" />
                    </a>
                  </div>
                </motion.div>

                {/* Screenshot Placeholder */}
                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.7,
              delay: 0.15,
              ease: [0.25, 0.1, 0.25, 1]
            }} className="w-full lg:w-7/12" data-id="element-2877">
                  <div className="w-full rounded-2xl overflow-hidden shadow-xl ring-1 ring-black/5" data-id="element-2878">
                    <img src={step.image} alt={step.alt} className="w-full h-auto block" loading="lazy" data-id="element-2879" />
                  </div>
                </motion.div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}